module.exports = __webpack_public_path__ + "img/staunty.fa0ccda5.png";